import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {

  constructor() { }

  loadZendesk(key: string) {

    const script = document.createElement('script');

    script.id = "ze-snippet";

    script.src = 
    `https://static.zdassets.com/ekr/snippet.js?key=${key}`;

    document.body.appendChild(script);
  }
}
